import { Component, OnInit } from '@angular/core';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { AppState } from 'src/app/App.state';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/global/services/dialog.service';
import {
  ParcelaChatbotEvent,
  VisualizarParcelaChatbotFilterOptions,
} from 'src/app/global/lists/parcela-chatbot-list/parcela-chatbot-list.component';
import { Page } from '../../domain/return-api.model';
import { PesquisaMapa } from '../../domain/pesquisa-mapa.model';
import { PesquisaMapaService } from '../../services/pesquisa-mapa-service';
import { PesquisaMapaEvent } from '../pesquisa-mapa-list/pesquisa-mapa-list/pesquisa-mapa-list.component';
import { PesquisaMapaFormComponent } from '../pesquisa-mapa-form-cadastrar/pesquisa-mapa-form.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-pesquisa-mapa-main',
  templateUrl: './pesquisa-mapa-main.component.html',
  styleUrls: ['./pesquisa-mapa-main.component.css']
})
export class PesquisaMapaMainComponent implements OnInit {

   private static ADICIONAR_ESTABELECIMENTO = 'Adicionar Estabelecimento';
 
   queryOptions = new QueryOptions({ pageSize: 25 });
 
   page: Page<PesquisaMapa> = new Page();
   totalRecords: number = 0;
 
   loading: boolean = false;
 
   constructor(
     private service: PesquisaMapaService,
     public appState: AppState,
     private dialog: MatDialog,
     private dialogService: DialogService,
   ) {
     const date = new Date();
     date.setHours(0, 0, 0);
     this.queryOptions.params = {
       dataInicio: date.getTime(),
       dataFim: new Date().getTime(),
     };
   }
 
   ngOnInit(): void {
    this.list();
   }
 
   list(pageNumber: number = 0): void {
     this.loading = true;
     //this.appState.isLoading = true;
     this.queryOptions.pageNumber = pageNumber + 1;
 
     const dataInicio: Date = new Date(this.queryOptions.params.dataInicio as number);
     dataInicio.setHours(0, 0, 0);
     const dataFim = new Date(this.queryOptions.params.dataFim as number);
     dataFim.setHours(23, 59, 59);
 
     this.queryOptions.params = {
       dataInicio: dataInicio.getTime(),
       dataFim: dataFim.getTime(),
     };
 
     this.service.findAllPageable(this.queryOptions).subscribe((response: Page<PesquisaMapa>) => {
       this.loading = false;
       this.appState.isLoading = false;
        console.log(this.loading);
       this.totalRecords = response.totalElements;
 
       response.content = this.mapearAcoes(response.content);
       this.page = response;
     });
   }
 
   mapearAcoes(pesquisa: PesquisaMapa[]): PesquisaMapa[] {
     const mapearAcoes = (arquivo: PesquisaMapa): PesquisaMapa => {
       const acoes = [];
       acoes.push(PesquisaMapaMainComponent.ADICIONAR_ESTABELECIMENTO);
       return { ...arquivo, acoes };
     };
 
     return pesquisa?.map(mapearAcoes) ?? [];
   }
 
   onFilter(options: VisualizarParcelaChatbotFilterOptions): void {
     const date = new Date();
     date.setHours(0, 0, 0, 0);
 
     this.queryOptions.params = {
       dataInicio: options.dataInicial ? options.dataInicial.getTime() : date.getTime(),
       dataFim: options.dataFinal ? options.dataFinal.getTime() : date.getTime(),
     };
 
     this.list();
   }
 
   async onAcaoClick(event: PesquisaMapaEvent) {
    
   }
 
   async realizarAssociacao(parcelaChatbot: ParcelaChatbotEvent): Promise<void> {}
   
    onLoadArquivosPage(pageNumber: number): void {
    this.list(pageNumber);
  }
  showSuccessToast(arg0: string) {
    throw new Error('Method not implemented.');
  }
  onAtualizar() {
    throw new Error('Method not implemented.');
  }

  onMenuAcaoClick($event: any) {
      this.dialog
              .open(PesquisaMapaFormComponent, {
                height:'800px',
                width: '800px',
              })
              .afterClosed()
              .subscribe((form) => {
                if (form) {
                  this.service.createPesquisa(form).subscribe(
                    (response) => {
                      if (response) {
                        this.dialogService.feedbackSuccess('Pesquisa Cadastrada com Sucesso!').then((_) => this.list(0));
                      }
                    },
                    (error: HttpErrorResponse) => {
                      this.dialogService.feedbackError('Ocorreu um erro ao cadastrar Pesquisa: ' + error.error);
                    },
                  );
                }
              });
  }


}
